import { render, staticRenderFns } from "./code-edit.vue?vue&type=template&id=7845a92d&scoped=true"
import script from "./code-edit.vue?vue&type=script&lang=js"
export * from "./code-edit.vue?vue&type=script&lang=js"
import style0 from "./code-edit.vue?vue&type=style&index=0&id=7845a92d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7845a92d",
  null
  
)

export default component.exports